import React, { FC } from "react";
import { DialogTitle as MuiDialogTitle } from "@mui/material";

type Props = React.ComponentProps<typeof MuiDialogTitle>;

const DialogTitle: FC<Props> = (props) => {
    return <MuiDialogTitle {...props}/>
}

export default DialogTitle;